import type { SVGProps } from 'react';
const SvgCloseSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
    <g clipPath="url(#close-small_svg__a)">
      <path
        fill="currentColor"
        d="M12 0C5.372 0 0 5.373 0 12s5.372 12 12 12 12-5.373 12-12S18.628 0 12 0m5.56 15.44a1.5 1.5 0 1 1-2.12 2.12L12 14.122l-3.44 3.44a1.495 1.495 0 0 1-2.12 0 1.5 1.5 0 0 1 0-2.121L9.878 12l-3.44-3.44A1.5 1.5 0 0 1 8.56 6.44L12 9.878l3.44-3.44a1.5 1.5 0 0 1 2.12 2.121L14.122 12z"
      />
    </g>
    <defs>
      <clipPath id="close-small_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCloseSmall;
